import * as React from 'react';
import styled from 'styled-components';
import { SectionInfoNarrow } from '../layout/SectionInfoNarrow';
import { Container } from '../layout/Container';
import { LogoContainer } from '../ui/logo/LogoContainer';
import { SectionContact } from '../layout/SectionContact';
import { Overlap } from '../layout/Overlap';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { SectionServices } from '../layout/SectionServices';
import { useParams } from 'react-router';
import { useLazyQuery, useQuery } from '@apollo/client';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import {
  Query,
  QueryGetOfficeArgs,
  QueryGetPageContentInputArgs,
} from '../../../client/types/generated/types';
import { ImageCarousel } from '../layout/carousel/ImageCarousel_v1';
import { PageContentType } from '../../../server/global/enum';
import { CustomerCard } from '../layout/CustomerCard';
import { IsValidUrl } from '../../utils/helpers/url';
import { H1 } from '../layout/HeaderTitle';

//GraphQL
import { ALL_NEWS_QUERY } from '../../../client/__graphql__/queries/getAllNews';
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';
import {
  NewsType,
  NewsSearchTypes,
} from '../../../client/types/generated/types';
import { Heading } from '../ui/text/Heading';
import { Line } from '../ui/divider/Line';
import LeftQuote from '../ui/symbol/quotes/LeftQuote';
import RightQuote from '../ui/symbol/quotes/RightQuote';
import CustomerRefText from '../layout/CustomerRefText';
import CustomerRefContainer from '../layout/CustomerRefContainer';

const CustomerWrapper = styled.div`
  padding-top: 0em;
  padding-bottom: 2em;
  width: 100%;
  margin: 0 auto;
  display: grid;
  justify-items: center;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 3em;
  grid-row-gap: 3em;

  @media all and (max-width: 1400px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  @media all and (max-width: 1247px) {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 500px;
  }

  @media all and (max-width: 600px) {
    padding-top: 2em;
    grid-row-gap: 3em;
  }

  @media all and (min-width: 375px) {
    margin-top: 2em !important;
  }

  /*   .RefPerson{
    
  } */
`;

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const OurCustomers: React.FC = () => {
  const params = useParams<{ urltag: string }>();
  const [showReference, setShowReference] = React.useState(false);

  const { data, loading } = useQuery<GetPageItem, QueryGetPageContentInputArgs>(
    CONTENT_ITEM,
    {
      skip: !params.urltag,
      fetchPolicy: 'network-only',
      variables: {
        input: { urltag: params.urltag, type: PageContentType.CUSTOMER },
      },
      onCompleted: (data: any) => {
        getItems({
          variables: {
            input: {
              urltag: params?.urltag ? params.urltag : '',
              type: NewsType.Nybyggportal,
              category_type: 'nybygg-kunder',
              published: true,
              active: 1,
              page: 0,
              limit: 50,
            },
          },
        });
      },
    }
  );

  const [getItems, { data: items, loading: itemsLoading }] = useLazyQuery(
    ALL_NEWS_QUERY,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data: any) => {
        if (data?.getAllNews?.list && data?.getAllNews?.list?.length > 0) {
          const res = data?.getAllNews?.list.findIndex(function (
            itm: any,
            index: number
          ) {
            if (itm?.ingress) {
              return true;
            }
            return false;
          });

          setShowReference(res > -1);
        }
      },
    }
  );

  const GetUrl = (item: any) => {
    if (item) {
      if (IsValidUrl(item?.externalUrl)) {
        return item?.externalUrl;
      }

      if (item?.slug) {
        if (params?.urltag || item?.officetag) {
          return `/kontor/${params.urltag}/kunde/${item.slug}`;
        }
        return null;
      }
    }

    return '';
  };

  if (loading) {
    return null;
  }

  return (
    <>
      <Seo
        title={`Våre kunder - PrivatMegleren - ${data?.getNdPageContent?.seo?.title}`}
        image={
          data?.getNdPageContent?.seo?.image
            ? data?.getNdPageContent?.seo?.image
            : undefined
        }
        description={
          data?.getNdPageContent?.seo?.text
            ? data?.getNdPageContent?.seo?.text
            : undefined
        }
      />
      <Page>
        <ImageCarousel
          title={data?.getNdPageContent?.title}
          url={data?.getNdPageContent?.image}
          imageList={data?.getNdPageContent?.imageList}
          get_properties={false}
        />
        <Overlap yPos={-70}>
          <SectionInfoNarrow
            title={
              data?.getNdPageContent?.title
                ? data?.getNdPageContent?.title
                : 'Våre kunder'
            }
            hidedivider={false}
            ingress={
              data?.getNdPageContent?.ingress
                ? data?.getNdPageContent?.ingress
                : '<p>Vi er stolte over vårt samarbeid med disse kundene</p>'
            }
            info={data?.getNdPageContent?.text}
          >
            {items?.getAllNews?.total && items?.getAllNews?.total > 0 ? (
              <>
                <CustomerWrapper>
                  {items?.getAllNews?.list?.map((item: any, index: any) => {
                    return (
                      <CustomerCard
                        key={`c` + index}
                        image={item?.image}
                        title={item?.title ? item.title : ''}
                        url={GetUrl(item)}
                        style={{ height: '100%' }}
                      />
                    );
                  })}
                </CustomerWrapper>
              </>
            ) : null}
            {showReference ? (
              <>
                <H1 style={{ marginTop: '25px' }}>Referanser</H1>
                <Line style={{ marginBottom: '45px' }} />
                <CustomerRefContainer>
                  {items?.getAllNews?.list?.map((item: any, index: any) => {
                    if (item?.ingress) {
                      return (
                        <CustomerRefText key={`cref-${index}`}>
                          <LeftQuote />
                          <h2 className="customer-title">
                            {item?.title ? item.title : ''}
                          </h2>
                          <span
                            dangerouslySetInnerHTML={{ __html: item?.ingress }}
                          />
                          <RightQuote />
                        </CustomerRefText>
                      );
                    }
                  })}
                </CustomerRefContainer>
              </>
            ) : null}
          </SectionInfoNarrow>
        </Overlap>
        {data?.getNdPageContent?.config?.showSubpageNews ? (
          <SectionNewsCard />
        ) : null}
        {data?.getNdPageContent?.config?.showSubpageServices ? (
          <SectionServices style={{ position: 'relative', top: '2em' }} />
        ) : null}
        {data?.getNdPageContent?.config?.showSubpageContact ? (
          <SectionContact />
        ) : null}
      </Page>
    </>
  );
};

export default OurCustomers;

/*
<Heading tag="h2" center={true}>
                Referanser
                <Line style={{ margin: '15px auto' }} />
              </Heading>
*/
